export const FORM_STATUS = {
    DRAFT: 'draft',
    ACTIVE: 'active',
    CLOSED: 'closed',
}

export const SUBMISSION_STATUS = {
    DRAFT: 'draft',
    SUBMITTED: 'submitted',
    PROCESSING: 'processing',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    SHARED: 'shared',
    ARCHIVED: 'archived',
}

export const FORM_STATUS_TRANSLATION = {
    [FORM_STATUS.DRAFT]: trans('general.page.space_forms.status.draft'),
    [FORM_STATUS.ACTIVE]: trans('general.page.space_forms.status.active'),
    [FORM_STATUS.CLOSED]: trans('general.page.space_forms.status.closed'),
}